module.exports = __webpack_public_path__ + "static/img/similar-search-1.37caafa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/similar-search-1.jpg
// module id = 5hm5
// module chunks = 0